import {tns} from '../../../../node_modules/tiny-slider/src/tiny-slider'

export default function () {
    const selectors = {
        main: '.b-plates-slider',
        slider: '.b-plates-slider__slider',
        btnPrev: '.b-plates-slider__btn_prev',
        btnNext: '.b-plates-slider__btn_next',
    };

    const classes = {
        shadowExists: 'b-plates-slider_shadow-exists'
    };

    $(`${selectors.main}.js-init`).each((i, elem) => {
       initSlider($(elem));
    });

    function initSlider($elem) {
        const elems = {
            $main: $elem,
            $slider: $elem.find(selectors.slider),
            $btnPrev: $elem.find(selectors.btnPrev),
            $btnNext: $elem.find(selectors.btnNext),
        };

        const inlineSliderOptions = elems.$main.data('slider-options') || {};

        const sliderDefaults = {
            container: elems.$slider.get(0),
            items: 3,
            prevButton: elems.$btnPrev.get(0),
            nextButton: elems.$btnNext.get(0),
            speed: 500,
            responsive: {
                1024: {
                    items: 3
                },
                768: {
                    items: 2
                },
                320: {
                    items: 1
                }
            }
        }

        const slider = tns({
            ...sliderDefaults,
            ...inlineSliderOptions
        })
    }
}
